import React, { useEffect, useState } from "react";
import { Dropdown } from "antd";
import GradientBarChart from "../../../../components/dashboard/analytics/chart/GradientBarChart";
import { ProgressService } from "../../../../services/progress-api.service";
import {
  DropDownCheck,
  SFilterIcon,
} from "../../../../../assets/icons/defaultIcons";
import ProgressChartSkeleton from "../../../skeletons/home/ProgressChartSkeleton";
import dayjs from "dayjs";
import { useUser } from "../../../../providers/UserContext";

export default function ProgressChart() {
  const [progressData, setProgressData] = useState([]);
  const [pointsData, setPointsData] = useState([]);
  const [selectedItem, setSelectedItem] = useState("Weekly");
  const [loader, setLoader] = useState(false);
  const [points, setPoints] = useState();
  const {
    pointUpdate,
    setPointUpdate,
    setChartUpdate,
    chartUpdate,
    setChartSelected,
    chartSelected,
    chartFilterType,
    setChartFilterType,
  } = useUser();

  async function GetPointsData(
    filterType = chartFilterType,
    selected = chartSelected
  ) {
    setChartSelected(selected);
    setChartFilterType(filterType);
    let dayChart = true;
    let weekChart = false;
    let monthChart = false;

    switch (filterType) {
      case 10:
        dayChart = true;
        weekChart = false;
        monthChart = false;
        break;
      case 20:
        dayChart = false;
        weekChart = true;
        monthChart = false;
        break;
      case 30:
        dayChart = false;
        weekChart = false;
        monthChart = true;
        break;
      default:
        dayChart = true;
        weekChart = false;
        monthChart = false;
        break;
    }

    // setLoader(true)
    const response = await ProgressService.getProgressData(
      false,
      false,
      false,
      dayChart,
      weekChart,
      monthChart
    );

    const sumOfTotalPoints = response.data?.data?.data.reduce(
      (acc, curr) => acc + curr.totalPoints,
      0
    );
    setPoints(sumOfTotalPoints);

    if (response?.data?.status) {
      setPointsData(response.data?.data?.data);
      switch (filterType) {
        case 10:
          setPointsData(
            response.data?.data?.data.map((data) => {
              // Create a date string in a format that dayjs can parse (ISO format: YYYY-MM-DD)
              const dateString = `${data.year}-${data.month}-${data.day}`;
              const date = dayjs(dateString);

              // Get the day of the week, dayjs().day() returns a number from 0 (Sunday) to 6 (Saturday)
              const dayOfWeek = date.day();

              // Optionally, convert day number to day name if needed
              const dayName = date.format("ddd"); // This will give you "Monday", "Tuesday", etc.

              return {
                totalPoints: data.totalPoints,
                xLabel: `${dayName}`, // Example: "Tuesday, 5/13"
              };
            })
          );
          break;
        case 20:
          setPointsData(
            response.data?.data?.data.map((data) => {
              return {
                totalPoints: data.totalPoints,
                xLabel: `Week ${data.week}`,
              };
            })
          );
          break;
        case 30:
          setPointsData(
            response.data?.data?.data.map((data) => {
              // Use dayjs to format the month number into a month name
              const monthName = dayjs(`${data.year}-${data.month}-01`).format(
                "MMMM"
              ); // 'MMMM' format gives the full month name

              return {
                totalPoints: data.totalPoints,
                // Include the month name in the xLabel
                xLabel: `${monthName}`,
              };
            })
          );
          break;
        default:
          break;
      }
      // setLoader(false)
    }
  }

  useEffect(() => {
    GetPointsData();
  }, [pointUpdate]);

  const items = [
    {
      key: "1",
      label: (
        <a
          onClick={() => {
            GetPointsData(10, "Weekly");
          }}
          className={"d-flex justify-content-between w-100"}
        >
          Weekly{" "}
          {chartSelected === "Weekly" && (
            <span>
              <DropDownCheck />
            </span>
          )}
        </a>
      ),
    },
    {
      key: "2",
      label: (
        <a
          onClick={() => {
            GetPointsData(20, "Monthly");
          }}
          className={"d-flex justify-content-between w-100"}
        >
          Monthly{" "}
          {chartSelected === "Monthly" && (
            <span>
              <DropDownCheck />
            </span>
          )}
        </a>
      ),
    },
    {
      key: "3",
      label: (
        <a
          onClick={() => {
            GetPointsData(30, "Quaterly");
          }}
          className={"d-flex justify-content-between w-100"}
        >
          Quaterly{" "}
          {chartSelected === "Quaterly" && (
            <span>
              <DropDownCheck />
            </span>
          )}
        </a>
      ),
    },
  ];

  if (loader) {
    return <ProgressChartSkeleton />;
  }

  return (
    <div className={"chart-box"}>
      <div className={"chart-box-header"}>
        <div>
          <h3>Progress</h3>
          <h4>
            <span>{points}</span> Points
          </h4>
        </div>
        <div>
          <Dropdown
            menu={{ items }}
            placement="bottomLeft"
            trigger={"click"}
            loading={loader}
            onClick={(e) => console.log("onclick event", e)}
          >
            <span className={"theme-dropdown-1"}>
              <SFilterIcon /> {chartSelected ? chartSelected : ""}
            </span>
          </Dropdown>
        </div>
      </div>
      <div>
        {!loader && (
          <GradientBarChart data={pointsData} selectedItem={chartSelected} />
        )}
      </div>
    </div>
  );
}
